// extracted by mini-css-extract-plugin
export default {"titleWrap":"ChatModalV2_titleWrap__GhOhW","spanId":"ChatModalV2_spanId__RK+gH"};